import { IRentsyncProperties } from '@llws/lift-entity-interfaces';
import { DataModifyProcessor } from '@/shared/classes/data-modify-processor';
import { adminRequest } from '@/shared/request-configs/admin-request';
import config from '@/config';

/**
 * Saves Single Rentsync Property <br>
 * API Endpoints:
 * <li>`/syndication-api/rentsync_properties/${data.id}` <br> via {@link adminRequest.put}</li>
 * <li>'/syndication-api/rentsync_properties' <br> via {@link adminRequest.post}</li>
 * @param {IRentsyncProperties} data - rentsync property to save
 */
export const save = async (
  data: IRentsyncProperties,
) => (data.id
  ? (await adminRequest.put(`/syndication-api/rentsync_properties/${data.id}`, data)).data
  : (await adminRequest.post('/syndication-api/rentsync_properties', data)).data
);

/**
 * Saves Multiple Rentsync Properties <br>
 * API Endpoint - `/syndication-api/rentsync_properties` <br> via {@link DataModifyProcessor.execute}
 * @param {IRentsyncProperties[]} data - rentsync properties to save
 */
export const saveBulk = async (data: IRentsyncProperties[]) => {
  const processor = new DataModifyProcessor<IRentsyncProperties>(`${config.adminGateway}/syndication-api/rentsync_properties`);

  processor.postItems = data.filter((d) => !d.id);
  processor.putItems = data.filter((d) => d.id);

  return processor.execute();
};

export default {
  save,
  saveBulk,
};
